import React from 'react'

interface BackArrowProps {
  width?: number,
  height?: number,
  color?: string
}

const BackArrow = ({ height = 16, width = 26, color='#000000' }: BackArrowProps) => {
  return (
    <svg
      className="drift-default-icon drift-default-icon--back-arrow"
      width={width}
      height={height}
      viewBox="0 0 10 19">
        <path
          fill={color}
          d="M9.70711 0.542893C10.0976 0.933418 10.0976 1.56658 9.70711 1.95711L2.41421 9.25L9.70711 16.5429C10.0976 16.9334 10.0976 17.5666 9.70711 17.9571C9.31658 18.3476 8.68342 18.3476 8.29289 17.9571L0.292893 9.95711C0.105357 9.76957 -4.04995e-07 9.51522 -3.93402e-07 9.25C-3.81809e-07 8.98478 0.105357 8.73043 0.292893 8.54289L8.29289 0.542893C8.68342 0.152369 9.31658 0.152369 9.70711 0.542893Z"
          clipRule="evenodd"
          fillRule="evenodd"
        />
      </svg>

  )
}

export default BackArrow
